import { useMemo } from 'preact/hooks';

export const usePrices = result => {
  return useMemo(() => {
    const countryCode = window.Resources.country_code;
    let variantPricesAttribute = 'variant_price';
    let variantCompareAtPricesAttribute = 'variant_compare_at_price';

    // switch (countryCode) {
    //   case 'CA': {
    //     variantPricesAttribute = 'variant_mfield_cql_price_cad';
    //     variantCompareAtPricesAttribute = 'variant_mfield_cql_price_compare_at_cad';
    //     break;
    //   }
    //   default:
    // }

    const variantPrices = result?.attributes?.[variantPricesAttribute] ?? null;
    const variantCompareAtPrices = result?.attributes?.[variantCompareAtPricesAttribute] ?? null;
    let maxCompareAtPrice = null;

    const variantPriceNumbers = variantPrices?.map(p => Number(p)).filter(Boolean);

    const minPrice = variantPriceNumbers?.length > 0 ? Math.min(...variantPriceNumbers) : null;
    const maxPrice = variantPriceNumbers?.length > 0 ? Math.max(...variantPriceNumbers) : null;

    if (variantCompareAtPrices != null) {
      const variantCompareAtPriceNumbers = variantCompareAtPrices.map(p => Number(p)).filter(Boolean);
      maxCompareAtPrice = variantCompareAtPriceNumbers.length > 0 ? Math.max(...variantCompareAtPriceNumbers) : null;
    }

    return { minPrice, maxPrice, maxCompareAtPrice, variantPrices };
  }, [result]);
};
